const FULLSCREEN_SHORTCUT = "Ctrl+Shift+F";
let bound = false;

export const bindFullscreen = (): void => {
  if (!bound) {
    document.addEventListener("click", handleClick);
    document.addEventListener("fullscreenchange", syncFullscreenButtons);
    window.addEventListener("keydown", handleShortcut);
    bound = true;
  }
  syncFullscreenButtons();
};

const handleClick = (event: MouseEvent): void => {
  if (!(event.target instanceof Element) || !event.target.closest("[data-fullscreen]")) return;
  void toggleFullscreen();
};

const handleShortcut = (event: KeyboardEvent): void => {
  const customShortcut = (event.ctrlKey || event.metaKey) && event.shiftKey && event.key.toLowerCase() === "f";
  if ((!customShortcut && event.key !== "F11") || event.repeat || isEditableTarget(event.target)) return;
  event.preventDefault();
  void toggleFullscreen();
};

const toggleFullscreen = async (): Promise<void> => {
  try {
    if (document.fullscreenElement) await document.exitFullscreen();
    else if (document.documentElement.requestFullscreen) await document.documentElement.requestFullscreen();
  } catch {
    // Fullscreen can be denied by browser policy; leave the page usable.
  }
};

const syncFullscreenButtons = (): void => {
  const active = Boolean(document.fullscreenElement);
  const supported = Boolean(document.documentElement.requestFullscreen);
  for (const button of document.querySelectorAll<HTMLButtonElement>("[data-fullscreen]")) {
    button.disabled = !supported;
    button.textContent = active ? "EXIT" : "FULL";
    button.setAttribute("aria-pressed", String(active));
    button.title = supported
      ? `${active ? "Exit" : "Enter"} fullscreen (${FULLSCREEN_SHORTCUT})`
      : "Fullscreen is not supported by this browser";
  }
};

const isEditableTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName);
};
